export default "__VITE_ASSET__rIL43gGT__"